import { render, staticRenderFns } from "./bullSemenProposal.vue?vue&type=template&id=dba76f92&scoped=true&"
import script from "./bullSemenProposal.vue?vue&type=script&lang=js&"
export * from "./bullSemenProposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba76f92",
  null
  
)

export default component.exports